// @flow

import React from "react";
import { MapSearchContext } from "../MapSearchContainer";
import { MapContainer as LeafletMap, TileLayer } from "react-leaflet";
import MarkersList from "../MarkersList";

const getMapBounds = (markers) => {
  let bounds = [];
  let hashes = [];
  markers.forEach((marker) => {
    const { latitude, longitude } = marker;
    var k = latitude + "|" + longitude;
    if (!hashes.includes(k)) {
      hashes.push(k);
      const value = { latitude, longitude };
      bounds.push(value);
    }
  });
  return bounds.map(({ latitude, longitude }) => [latitude, longitude]);
};

const MapContainer = ({ markers }) => {
  if (markers.length === 0) {
    return "";
  }
  const bounds = getMapBounds(markers);
  let mapParameters = { scrollWheelZoom: false };

  if (bounds.length > 1) {
    mapParameters.bounds = bounds;
  } else if (bounds.length === 1) {
    mapParameters.center = bounds[0];
    mapParameters.zoom = 5;
  }
  mapParameters.style = { width: "100%" }; //height defined in css

  return (
    <LeafletMap {...mapParameters}>
      <TileLayer
        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
      />
      <MarkersList />
    </LeafletMap>
  );
};

export default MapContainer;
